import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import notices, { noticesSaga } from './notices';
import noticeFiles, { noticeFilesSaga } from './noticeFiles';

const noticeModule = combineReducers({
    notices,
    noticeFiles,
});

export function* noticeModuleSaga() {
    yield all([
        noticesSaga(),
        noticeFilesSaga(),
    ]);
}

export default noticeModule;
